"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResponseCodes = exports.SupportedChainIds = void 0;
var SupportedChainIds;
(function (SupportedChainIds) {
    SupportedChainIds["MAINNET"] = "0x534e5f4d41494e";
    SupportedChainIds["TESTNET"] = "0x534e5f474f45524c49";
})(SupportedChainIds = exports.SupportedChainIds || (exports.SupportedChainIds = {}));
var ResponseCodes;
(function (ResponseCodes) {
    ResponseCodes["SUCCESS"] = "SUCCESS";
    ResponseCodes["NOT_CONNECTED"] = "NOT_CONNECTED";
    ResponseCodes["NOT_ALLOWED"] = "NOT_ALLOWED";
    ResponseCodes["CANCELED"] = "CANCELED";
})(ResponseCodes = exports.ResponseCodes || (exports.ResponseCodes = {}));
//# sourceMappingURL=types.js.map